module.exports = __webpack_public_path__ + "img/body-2.f9e929d5.png";